import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
    useGetBacklogDataQuery,
    useGetBlockedDataQuery,
    useGetDoingDataQuery,
    useGetDoneDataQuery,
    useGetReadyDataQuery,
    useGetReviewDataQuery,
} from "../Features/projects/projectsApi";
import CreateProject from "../shared/CreateProject";
import DeleteBacklogModal from "../shared/DeleteBacklogModal";
import ProjectsNavbar from "../shared/ProjectsNavbar";

const Projects = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [filter, setFilter] = useState(undefined);
    const [backlogData, setBacklogData] = useState([]);
    const [deletationId, setDelationId] = useState(null);
    const { data: backLogData, isLoading } = useGetBacklogDataQuery();
    const { data: ReadyData } = useGetReadyDataQuery();
    const { data: DoingData } = useGetDoingDataQuery();
    const { data: ReviewData } = useGetReviewDataQuery();
    const { data: BlockedData } = useGetBlockedDataQuery();
    const { data: DoneData } = useGetDoneDataQuery();
    const [openBacklogCardOption, setBacklogCardOption] = useState(false);
    const [openBacklogCardOptionNumber, setBacklogCardOptionNumber] =
        useState(0);

    const searchTerm = useSelector((state) => state.filter);

    useEffect(() => {
        if (searchTerm !== null) {
            setFilter(searchTerm?.searchTerm);
        }
    }, [searchTerm]);

    useEffect(() => {
        if (!isLoading) {
            setBacklogData(backLogData);
        }
    }, [isLoading, backLogData]);

    const control = () => {
        setIsOpen(!isOpen);
    };

    const deleteControl = () => {
        setOpenDeleteModal(!openDeleteModal);
    };

    const handleBacklogDelete = async (id) => {
        deleteControl();
        setDelationId(id);
    };

    return (
        <div>
            <div
                class="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200"
                onClick={() => setBacklogCardOption(!openBacklogCardOption)}
            >
                <ProjectsNavbar />
                <div class="px-10 mt-6">
                    <h1 class="text-2xl font-bold">Project Board</h1>
                </div>
                <div class="flex flex-grow px-10 mt-4 space-x-6 overflow-auto">
                    {/*Backlog part start*/}
                    <div class="flex flex-col flex-shrink-0 w-72">
                        <div class="flex items-center flex-shrink-0 h-10 px-2">
                            <span class="block text-sm font-semibold">
                                Backlog
                            </span>
                            <span class="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                                {backlogData?.length}
                            </span>
                            <button
                                class="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <svg
                                    class="w-5 h-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div class="flex flex-col pb-2 overflow-auto">
                            {backlogData?.map((card) => {
                                return (
                                    <>
                                        <div
                                            class={`relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100   ${
                                                filter === null ||
                                                filter === undefined ||
                                                filter === ""
                                                    ? undefined
                                                    : `${
                                                          card?.description
                                                              ?.toLowerCase()
                                                              .includes(
                                                                  filter.toLowerCase()
                                                              )
                                                              ? "border-2 border-green-500"
                                                              : ""
                                                      }`
                                            } `}
                                            draggable="true"
                                            key={card?.id}
                                        >
                                            <button
                                                class="absolute top-0 right-0 flex items-center justify-center hidden w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex"
                                                onClick={() => {
                                                    setBacklogCardOption(
                                                        !openBacklogCardOption
                                                    );
                                                    setBacklogCardOptionNumber(
                                                        card?.id
                                                    );
                                                }}
                                            >
                                                <svg
                                                    class="w-4 h-4 fill-current"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                >
                                                    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                                </svg>
                                            </button>
                                            <span
                                                class={`flex items-center h-6 px-3 text-xs font-semibold text-${card?.team.color}-500 bg-${card?.team.color}-100 rounded-full`}
                                            >
                                                {card?.team?.name}
                                            </span>
                                            <h4 class="mt-3 text-sm font-medium">
                                                {card?.description}
                                            </h4>
                                            <div class="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                                <div class="flex items-center">
                                                    <svg
                                                        class="w-4 h-4 text-gray-300 fill-current"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"
                                                        />
                                                    </svg>
                                                    <span class="ml-1 leading-none">
                                                        {moment(
                                                            card?.timestamp
                                                        ).format("ll")}
                                                    </span>
                                                </div>

                                                <img
                                                    class="w-6 h-6 ml-auto rounded-full"
                                                    src="https://randomuser.me/api/portraits/women/26.jpg"
                                                    alt="img"
                                                />
                                            </div>

                                            {openBacklogCardOption &&
                                                card?.id ===
                                                    openBacklogCardOptionNumber && (
                                                    <div className="absolute top-7 right-6 w-28 z-50 border-[0.5px] flex flex-col border-gray-200 h-auto bg-white shadow-4xl rounded-[4px]">
                                                        <button
                                                            className="text-xs w-full py-[2px] border-b-[0.5px] duration-300 hover:text-white hover:bg-red-400"
                                                            onClick={() =>
                                                                handleBacklogDelete(
                                                                    card?.id
                                                                )
                                                            }
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                )}
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>

                    {/*Ready part start*/}
                    <div class="flex flex-col flex-shrink-0 w-72">
                        <div class="flex items-center flex-shrink-0 h-10 px-2">
                            <span class="block text-sm font-semibold">
                                Ready
                            </span>
                            <span class="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                                {ReadyData?.length}
                            </span>
                        </div>
                        <div class="flex flex-col pb-2 overflow-auto">
                            {ReadyData?.map((card) => {
                                return (
                                    <>
                                        <div
                                            class="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                                            draggable="true"
                                        >
                                            <span
                                                class={`flex items-center h-6 px-3 text-xs font-semibold text-${card?.team?.color}-500
                                                 bg-${card?.team?.color}-100 rounded-full`}
                                            >
                                                {card?.team?.name}
                                            </span>
                                            <h4 class="mt-3 text-sm font-medium">
                                                {card?.description}
                                            </h4>
                                            <div class="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                                <div class="flex items-center">
                                                    <svg
                                                        class="w-4 h-4 text-gray-300 fill-current"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"
                                                        />
                                                    </svg>
                                                    <span class="ml-1 leading-none">
                                                        {moment(
                                                            card?.timestamp
                                                        ).format("ll")}
                                                    </span>
                                                </div>

                                                <img
                                                    class="w-6 h-6 ml-auto rounded-full"
                                                    src="https://randomuser.me/api/portraits/women/26.jpg"
                                                    alt="img"
                                                />
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>

                    {/*Doing part start*/}
                    <div class="flex flex-col flex-shrink-0 w-72">
                        <div class="flex items-center flex-shrink-0 h-10 px-2">
                            <span class="block text-sm font-semibold">
                                Doing
                            </span>
                            <span class="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                                {DoingData?.length}
                            </span>
                        </div>
                        <div class="flex flex-col pb-2 overflow-auto">
                            {DoingData?.map((card) => {
                                return (
                                    <>
                                        <div
                                            class="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                                            draggable="true"
                                        >
                                            <span
                                                class={`flex items-center h-6 px-3 text-xs font-semibold text-${card?.team?.color}-500
                                                 bg-${card?.team?.color}-100 rounded-full`}
                                            >
                                                {card?.team?.name}
                                            </span>
                                            <h4 class="mt-3 text-sm font-medium">
                                                {card?.description}
                                            </h4>
                                            <div class="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                                <div class="flex items-center">
                                                    <svg
                                                        class="w-4 h-4 text-gray-300 fill-current"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"
                                                        />
                                                    </svg>
                                                    <span class="ml-1 leading-none">
                                                        {moment(
                                                            card?.timestamp
                                                        ).format("ll")}
                                                    </span>
                                                </div>

                                                <img
                                                    class="w-6 h-6 ml-auto rounded-full"
                                                    src="https://randomuser.me/api/portraits/women/26.jpg"
                                                    alt="img"
                                                />
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>

                    {/*Review part start*/}
                    <div class="flex flex-col flex-shrink-0 w-72">
                        <div class="flex items-center flex-shrink-0 h-10 px-2">
                            <span class="block text-sm font-semibold">
                                Review
                            </span>
                            <span class="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                                {ReviewData?.length}
                            </span>
                        </div>
                        <div class="flex flex-col pb-2 overflow-auto">
                            {ReviewData?.map((card) => {
                                return (
                                    <>
                                        <div
                                            class="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                                            draggable="true"
                                        >
                                            <span
                                                class={`flex items-center h-6 px-3 text-xs font-semibold text-${card?.team?.color}-500
                                                 bg-${card?.team?.color}-100 rounded-full`}
                                            >
                                                {card?.team?.name}
                                            </span>
                                            <h4 class="mt-3 text-sm font-medium">
                                                {card?.description}
                                            </h4>
                                            <div class="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                                <div class="flex items-center">
                                                    <svg
                                                        class="w-4 h-4 text-gray-300 fill-current"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"
                                                        />
                                                    </svg>
                                                    <span class="ml-1 leading-none">
                                                        {moment(
                                                            card?.timestamp
                                                        ).format("ll")}
                                                    </span>
                                                </div>

                                                <img
                                                    class="w-6 h-6 ml-auto rounded-full"
                                                    src="https://randomuser.me/api/portraits/women/26.jpg"
                                                    alt="img"
                                                />
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>

                    {/* Blocked part start*/}
                    <div class="flex flex-col flex-shrink-0 w-72">
                        <div class="flex items-center flex-shrink-0 h-10 px-2">
                            <span class="block text-sm font-semibold">
                                Blocked
                            </span>
                            <span class="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                                {BlockedData?.length}
                            </span>
                        </div>
                        <div class="flex flex-col pb-2 overflow-auto">
                            {BlockedData?.map((card) => {
                                return (
                                    <>
                                        <div
                                            class="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                                            draggable="true"
                                        >
                                            <span
                                                class={`flex items-center h-6 px-3 text-xs font-semibold text-${card?.team?.color}-500
                                                 bg-${card?.team?.color}-100 rounded-full`}
                                            >
                                                {card?.team?.name}
                                            </span>
                                            <h4 class="mt-3 text-sm font-medium">
                                                {card?.description}
                                            </h4>
                                            <div class="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                                <div class="flex items-center">
                                                    <svg
                                                        class="w-4 h-4 text-gray-300 fill-current"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"
                                                        />
                                                    </svg>
                                                    <span class="ml-1 leading-none">
                                                        {moment(
                                                            card?.timestamp
                                                        ).format("ll")}
                                                    </span>
                                                </div>

                                                <img
                                                    class="w-6 h-6 ml-auto rounded-full"
                                                    src="https://randomuser.me/api/portraits/women/26.jpg"
                                                    alt="img"
                                                />
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>

                    {/* Done Part start*/}
                    <div class="flex flex-col flex-shrink-0 w-72">
                        <div class="flex items-center flex-shrink-0 h-10 px-2">
                            <span class="block text-sm font-semibold">
                                Done
                            </span>
                            <span class="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                                {DoneData?.length}
                            </span>
                        </div>
                        <div class="flex flex-col pb-2 overflow-auto">
                            {DoneData?.map((card) => {
                                return (
                                    <>
                                        <div
                                            class="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                                            draggable="true"
                                        >
                                            <span
                                                class={`flex items-center h-6 px-3 text-xs font-semibold text-${card?.team?.color}-500
                                                 bg-${card?.team?.color}-100 rounded-full`}
                                            >
                                                {card?.team?.name}
                                            </span>
                                            <h4 class="mt-3 text-sm font-medium">
                                                {card?.description}
                                            </h4>
                                            <div class="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                                <div class="flex items-center">
                                                    <svg
                                                        class="w-4 h-4 text-gray-300 fill-current"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"
                                                        />
                                                    </svg>
                                                    <span class="ml-1 leading-none">
                                                        {moment(
                                                            card?.timestamp
                                                        ).format("ll")}
                                                    </span>
                                                </div>

                                                <img
                                                    class="w-6 h-6 ml-auto rounded-full"
                                                    src="https://randomuser.me/api/portraits/women/26.jpg"
                                                    alt="img"
                                                />
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>
                    <div class="flex-shrink-0 w-6"></div>
                </div>
            </div>
            {isOpen && <CreateProject {...{ isOpen, control, backlogData }} />}
            {openDeleteModal && (
                <DeleteBacklogModal {...{ deleteControl, deletationId }} />
            )}
        </div>
    );
};

export default Projects;
